"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTION_NAME_MASK = exports.ACTION_NAME_PLACEHOLDER = exports.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE = void 0;
/**
 * Get the action name from the attribute 'data-dd-action-name' on the element or any of its parent.
 * It can also be retrieved from a user defined attribute.
 */
exports.DEFAULT_PROGRAMMATIC_ACTION_NAME_ATTRIBUTE = 'data-dd-action-name';
exports.ACTION_NAME_PLACEHOLDER = 'Masked Element';
exports.ACTION_NAME_MASK = 'xxx';
//# sourceMappingURL=actionNameConstants.js.map